module.exports = __webpack_public_path__ + "static/media/Bounsweet_gaussian2.a8519bab.png";